var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// var Popper = require('popper.js');
// window.Popper = Popper;
require('moment');
require('bootstrap');
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/util');
// require('bootstrap/js/dist/collapse');
// require('bootstrap/js/dist/dropdown');
// require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
// require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');

require('bootstrap-select');

// require('bootstrap-datepicker');
// require('bootstrap-material-design');



// require('jquery.placeholder');
require('jquery-sticky');
require('jquery-match-height');

require('owl.carousel');
require('lightbox2');
const WOW = require('wow.js');
require('magnific-popup');
// require('lazysizes');
// require('picturefill');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
var objectFitImages = require('object-fit-images');


$(function() {

    objectFitImages();
    // $('body').bootstrapMaterialDesign();
    // $('.nav-link').button('dispose')
    // Initialise the Ajax funxctions - put most of your js calls in this function
    // or if you need to reload them after an ajax call
    // initAjaxJS();

    // $(window).load(function() {
    // });

    // if ($('label input[type=radio]').length) {
    //     $('label input[type=radio]').each(function (el) {
    //         if ($(this).prop('checked')) {
    //             $(this).closest('label').addClass('active');
    //         }
    //     });

    //     $('input[type=radio]').on('input', function(e) {
    //         $(this).closest('.btn-group').find('label').removeClass('active');
    //         if ($(this).prop('checked')) {
    //             $(this).closest('label').addClass('active');
    //         }
    //     });
    // }

    if ($('.popup-youtube').length) {
        $('.popup-youtube').magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            gallery: {
                enabled: true
            },
        });
    }



    if ($('.filter__button').length) {
        $('.filter__button').click(function(e){
            e.preventDefault();
            $('.filter__button').toggleClass("filter__button--close");
            $('.filter__options').toggleClass("hide");
        });
    }

    $('.search-icon a').click(function(e){
        e.preventDefault();
        $('.search-icon__field').toggleClass("show");
    });

    $('.mob-nav__search').click(function(e){
        e.preventDefault();
        $('.mob-nav__search__field').toggleClass("show");
    });

    // $('.gf-tag__close').click(function () {
    //    $('.gf-tag__content').stop().slideToggle('slow');
    // });

    $(".gf-tag").click(function(e){
        e.preventDefault();
        $(".gf-tag__content").animate({
          width: "toggle"
        });
      });

    //wow.js animations
    new WOW().init();


    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    // Off canvas mobile nav
    $('[data-toggle="offcanvas"]').on('click', function() {
        $('.sidebar-offcanvas').toggleClass('active');
        $(this).toggleClass('btn-close')
        $('.main-nav--navbar-brand').toggleClass('active-mob');

    });


    if ($('.header-page').length){
        $('.main-nav--navbar-brand').addClass('active-pageheader');
    }


    var s = $(".main-nav");
    var pos = s.position();
    $(window).scroll(function() {
        var windowpos = $(window).scrollTop();
        if (windowpos >= pos.top & windowpos >=5) {
            s.addClass("main-nav--shadow");
        } else {
            s.removeClass("main-nav--shadow");
        }
    });



    if ($('.main-slider').length) {
        $('.main-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 77000,
            smartSpeed: 1000,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false,


        })
    }

    if ($('.sub-slider').length) {
        $('.sub-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 77000,
            smartSpeed: 1000,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false,
        })
    }

    if ($('.supporters').length) {
        $('.supporters').owlCarousel({
            // items:2,
            loop: true,
            margin: 0,
            dots: true,
            // dotsEach: true,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:1,
                    center: true
                },
                800:{
                    items:3
                },
                1000:{
                    items:4
                },
                1800:{
                    // items:4,
                    // startPosition: 2,
                    items:6
                    // autoWidth: true
                }
            }

        })
    }

    if ($('.insta-carousel').length) {
        $('.insta-carousel').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 4,
            nav: false,
            dot: true,
            autoplay: true,
            autoplayTimeout: 4000,
            smartSpeed: 750,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false,
            responsive: {

                0: {
                    items: 1,
                },

                576: {
                    items: 3,
                },
                768:{
                    items:4,
                    autoplay: false,
                },
                1200: {
                    items: 4,
                    autoplay: false,
                }
            }

        })
    }

    initFlipbook();


    scrollToFormError();
})

// scroll window to form error element and offset fixed header height
function scrollToFormError() {
    // console.log('scrollToFormError', window.location.hash);
    var windowWidth = $(window).width();
    var formStr = '#form-';
    // enquiry form error anchor offset
    if (window.location.hash && window.location.hash.indexOf(formStr) != -1) {

        var formEl = window.location.hash;
        if ($(formEl).length > 0) {

            // var offsetSize = $('.headerfixed').height();
            // console.log(window.location.hash+' '+offsetSize +' '+$(formEl).scrollTop());

            var offsetSize = $('#main-nav').height() + 30;
            if (windowWidth > 767) {
                // offset
                // animate scrollto
                $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
            } else {
                $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
            }

        }
    }
}

function initFlipbook() {
    if ($('#flipbookContainer').length > 0) {

        let pdf = $('#flipbookContainer').data('src');
        let pdf_options = {
            webgl: true,
            height: "auto",
            backgroundColor: "#f3f1f0",
            enableDownload: false,
            scrollWheel: false,
            allControls: "pageNumber,zoomIn,zoomOut,fullScreen",
            moreControls: "",
            hideControls: "altPrev,altNext,share,thumbnail,sound,pageMode,startPage,endPage,more",
            soundEnable: false,
        };

        flipBook = $("#flipbookContainer").flipBook(pdf, pdf_options);

        $('#brochure-tab').on('shown.bs.tab', function(e) {
            // fix hidden tab init issue
            flipBook.resize();
        });
    }
}


//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {


}


// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js